/**
 * Resolve database trigger IDs for a React Flow trigger node id.
 * Mirrors WorkflowController::updateNodesAndEdges trigger lookup.
 */
export async function fetchTriggerIdsForNode(workflowId, nodeId, csrfToken) {
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': csrfToken,
    Accept: 'application/json',
  }

  try {
    const response = await fetch(
      `/workflows/${workflowId}/nodes/${encodeURIComponent(nodeId)}/triggers`,
      { method: 'GET', headers },
    )

    if (response.ok) {
      const triggers = await response.json()
      if (Array.isArray(triggers) && triggers.length > 0) {
        return triggers.map((trigger) => trigger.id)
      }
    }
  } catch (error) {
    console.warn(`Failed to resolve triggers for node ${nodeId}:`, error)
  }

  if (typeof nodeId === 'string' && nodeId.startsWith('trigger-')) {
    const parsedId = parseInt(nodeId.replace('trigger-', ''), 10)
    if (Number.isInteger(parsedId) && parsedId > 0) {
      return [parsedId]
    }
  }

  return []
}

export async function saveTriggerPositionForNode(workflowId, nodeId, position, csrfToken) {
  const triggerIds = await fetchTriggerIdsForNode(workflowId, nodeId, csrfToken)

  if (triggerIds.length === 0) {
    console.warn(`No triggers resolved for node ${nodeId}, skipping position save`)
    return
  }

  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': csrfToken,
    Accept: 'application/json',
  }

  await Promise.allSettled(
    triggerIds.map(async (triggerId) => {
      const response = await fetch(`/workflows/${workflowId}/triggers/${triggerId}/position`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({
          position: JSON.stringify(position),
        }),
      })

      if (!response.ok) {
        console.warn(
          `Failed to update trigger ${triggerId} position for node ${nodeId}: ${response.status}`,
        )
      }
    }),
  )
}
